const parseBrand = (brands, brandId) => {
  if (!brands || !brands.size) return undefined;
  const brand = brands.valueSeq().toArray()
    .filter(brand => String(brand.get('id')) === String(brandId));

  return {
    id: brand[0].get('id'),
    name: brand[0].get('name'),
    logo: brand[0].get('logo'),
  }
};

export default parseBrand;




// WEBPACK FOOTER //
// ./src/helpers/parseBrand.js